import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { MatSnackBar } from '@angular/material/snack-bar';
import { Environment } from '../classes/environment';

import { ReportingYear } from 'src/app/classes/reportingData';

@Injectable({
    providedIn: 'root'
})
export class YearService {

	constructor(
        private _http: HttpClient,
		@Inject('environment') private environment: Environment,
		private matSnackBar: MatSnackBar,
	) {}

	getAll(): Observable<ReportingYear[]> {

		return this._http.get<ReportingYear[]>( this.environment.backendUrl + 'bj/all' ).pipe( 
			map( reportingYears => {
				// console.log( 'SECTIONS', sections )
				if( !reportingYears ) reportingYears = [];
				for( const r of reportingYears ) {
					if( !r.bjJahr ) r.bjJahr = '0';
				}
				return reportingYears;
			}),
			catchError(err => {
				console.log( 'An error occurred while fetching the list of reporting years', err );
				this.matSnackBar.open( 'Beim Abrufen der Berichtsjahr-Liste ist ein Fehler aufgetreten', '', { duration: 5000 } );
				// return throwError(err);
				return of([]);
			})
		);

	}

	getAllPublished(): Observable<ReportingYear[]> {
		return this.getAll().pipe(
			map( years => years.filter( year => year.bjFreigabe ) )
		);
	}

	getAllDrafts(): Observable<ReportingYear[]> {
		return this.getAll().pipe(
			map( years => years.filter( year => year.bjFreigabe ) )
		);
	}


	create( element: ReportingYear ): Observable<ReportingYear> {

		return this._http.post<{ verarbeitet: boolean, bj: ReportingYear }>( 
			this.environment.backendUrl + 'bj/new',
			element
		).pipe(
			map( response => {
				if( !response || !response.verarbeitet ) {
					this.matSnackBar.open( 'Erstellung fehlgeschlagen', '', { duration: 5000 } );
					return new ReportingYear();
				}
				this.matSnackBar.open( 'Erstellung gespeichert', '', { duration: 5000 } );
				return response.bj;
			}),
			catchError(err => {
				console.log( 'An error occurred while creating a reporting year', err );
				this.matSnackBar.open( 'Beim Erstellen einer Berichtsjahre ist ein Fehler aufgetreten', '', { duration: 5000 } );
				return of( new ReportingYear() );
			})
		)
	}

	update( element: ReportingYear ): Observable<boolean> {

		return this._http.put<ReportingYear>( 
			this.environment.backendUrl + 'bj/update',
			element
		).pipe(
			map( response => {
				if( !response ) {
					this.matSnackBar.open( 'Änderung fehlgeschlagen', '', { duration: 5000 } );
					return false;
				}
				this.matSnackBar.open( 'Änderung erfolgreich', '', { duration: 5000 } );
				return true;
			}),
			catchError(err => {
				console.log( 'An error occurred while updating a reporting year', err );
				this.matSnackBar.open( 'Beim Aktualisieren einer Berichtsjahre ist ein Fehler aufgetreten', '', { duration: 5000 } );
				return of(false);
			})
		)
	}

}
